import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled, {css} from 'styled-components';
import { rgba } from 'polished';
import { find } from 'lodash';
import { Link } from 'react-router-dom'
import moment from 'moment'
import Fade from 'react-reveal/Fade';

import { fetchPledges, getPledges} from './redux';
import { fetchDisciplines, getDisciplines } from '../../disciplines';

import PledgeForm from './PledgeForm'
import Check from 'svg-react-loader?name=Icon!../../assets/icons/check-white.svg';

import { paleGreen } from '../../styles/colors';
import { hoverState, body, padding } from '../../styles/global';
import { media, isClient } from '../../styles/utils';
import MetaTags from '../../components/MetaTags/MetaTags';


class Pledge extends Component{

    state = {
        pledgeType: null,
        mounted: false,
        activePledges: {

        }
    }

    componentWillMount = () => {
        const slug = this.props.match.params.slug;

        if (slug) {
            this.setState({
                pledgeType: slug
            })
        }
        
        this.props.fetchPledges()
        this.props.fetchDisciplines()
    }
    
    componentDidMount() {
        this.setState({
            mounted: true
        })
    }
    

    resolveColour = (pledgeType) => {
        const colours = {
            client: '#DB5537',
            artist: '#9A66FE',
            ['artist-rep']: '#B8EEB3'
        }

        return colours[pledgeType]
    }

    togglePledgeItem = (index) => {
        const { activePledges } = this.state;
        const newState = activePledges[`pledge${index}Active`] ? !activePledges[`pledge${index}Active`] : true;

        this.setState({
            activePledges: {
                ...activePledges,
                [`pledge${index}Active`]: newState
            }
        })
    }

    renderPledgeItems = () => {
        const { pledgeType } = this.state;
        const { pledges } = this.props;
        const pledgeData = find(pledges.data, (o) => { return o.slug == pledgeType })

        if (pledgeData) {
            const items = pledgeData.pledge_items.map((item, index) => {
                return (
                    <PledgeItem
                        onClick={() => this.togglePledgeItem(index)}
                    >
                        <Indicator
                            active={this.state.activePledges[`pledge${index}Active`]}
                        >
                            <Check/>
                        </Indicator>

                        {item.item}
                    </PledgeItem>
                )
            })
            return (
                <PledgeItems>
                    <Heading>Take the Pledge</Heading>
                    {items}
                </PledgeItems>
            )
        }
    }

    isUserPledged = () => {
        const { pledgeType, activePledges } = this.state;
        const { pledges } = this.props;
        const pledgeData = find(pledges.data, (o) => { return o.slug == pledgeType }) 

        let pledgesActive = 0;

        if (pledgeData) {
            const totalPledges = pledgeData.pledge_items.length;

            Object.keys(activePledges).forEach((key) => {
                if (activePledges[key] == true) {
                    pledgesActive++;
                }
            });

            if (pledgesActive == totalPledges) return true; 
        }

        return false;
    }
    
    render() {
        const { pledgeType, activePledges, mounted } = this.state;
        const { pledges, disciplines } = this.props;
        const pledgeData = find(pledges.data, (o) => { return o.slug == pledgeType })

        return (
            <Container>
                
                {pledgeData && (
                    <MetaTags
                        title={`The Pledge`}   
                        description={pledgeData.introduction}
                    />
                )}

                <LeftPanel
                    colour={this.resolveColour(pledgeType)}
                >
                    <Fade
                        duration={1000}
                    >
                        <Title>The Pledge</Title>
                    </Fade>
                </LeftPanel>

                <RightPanel>

                    {pledgeData && (
                        <Introduction>
                            <Text
                                dangerouslySetInnerHTML={{__html: pledgeData.introduction}}
                            />
                        </Introduction>
                    )}

                    {this.renderPledgeItems()}
                                    
                    {mounted && (
                        <PledgeForm 
                            type={pledgeType}
                            userPledged={this.isUserPledged()}
                            disciplines={disciplines}
                        />
                    )}

                </RightPanel>

            </Container>
        )
    }
}


const Container = styled.div`
    background: #F7F7F7;
    display: flex;
`

const panel = css`
    display: flex;
    width: 50vw;
    height: 100vh;
    max-height: 100vh;
`

const LeftPanel = styled.div`
    ${panel}
    background: ${props => props.colour};

    .react-reveal {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    ${media.tablet`
        display: none;
    `}
`

const Title = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
   
    font-family: Platform-Medium;
    font-size: 53px;
    color: white;
    letter-spacing: 0;
    text-align: center;
`

const RightPanel = styled.div`
    ${panel}
    background: white;
    box-sizing: border-box;
    flex-direction: column;
    overflow-y: scroll;

    ${media.tablet`
        width: 100vw;   
    `}
`

// Introduction

const Introduction = styled.div`
    background: #FCFCFC;
    padding: 0 64px;
    padding-top: 128px;
    padding-bottom: 81px;

    ${media.phone`
        padding: 48px 20px;
    `}
`

const Text = styled.div`
    p {
        ${body}
    }
`;

// Pledge Itmes

const PledgeItems = styled.div`
    padding-top: 80px;
    padding-bottom: 81px;
`

const Heading = styled.div`
    font-family: 'Platform-Regular';
    font-size: 14px;
    color: #4D4D4D;
    letter-spacing: 1.28px;
    text-align: left;
    line-height: 9px;
    text-transform: uppercase;
    margin-bottom: 38px;
    padding: 0 64px;

    ${media.phone`
        padding: 0 20px;
        text-align: center;
    `}
`
const PledgeItem = styled.div`
    display: flex;  
    align-items: flex-start;

    font-family: TiemposText-Regular;
    font-size: 15px;
    color: #4D4D4D;
    letter-spacing: 0;
    line-height: 27px;

    border-bottom: 1px solid #F6F6F6;
    padding-bottom: 22px;
    padding: 32px 64px 22px;
    cursor: pointer;

    transition: background 0.10s ease;

    &:hover {
        background-color: #FCFCFC;
    }

    &:active { 
        outline: none;
    }

    ${media.phone`
        padding: 32px 20px 22px;
        font-size: 13px;
        line-height: 22px;    
    `}
`

const Indicator = styled.div`
    width: 17px;
    height: 17px;   
    flex: 1 0 17px;
    max-width: 17px;
    border: 1px solid #C3C3C3;
    margin-right: 42px;
    transform: translateY(4px);
    border-radius: 50%;
    position: relative; 
    box-sizing: border-box;

    display: flex;
    justify-content: center;
    align-items: center;
    
    transition: all 0.10s ease;

    > * { 
        opacity: 0;
    }

    ${props => {
        if (props.active) return css`
            background: #7ED321;
            border: 2px solid #7ED321;
            border: 0;  

            > * { 
                opacity: 1;
            }
        `
    }}
`;

const mapDispatchToProps = dispatch => ({
    fetchPledges() {
        dispatch(fetchPledges())
    },
    fetchDisciplines() {
        dispatch(fetchDisciplines())
    }
})

const mapStateToProps = (state, props) => ({
    pledges: getPledges(state),
    disciplines: getDisciplines(state),
})

export default connect(mapStateToProps, mapDispatchToProps)(Pledge);


// WEBPACK FOOTER //
// ./client/modules/Pledge/Pledge.js